import { AppBar, Toolbar } from '@mui/material';
import { Outlet } from 'react-router';
import { makeStyles } from 'tss-react/mui';

import Header from './Header';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    backgroundColor: theme.palette.background.default,
  },
  content: {
    ...theme.typography.mainContent,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: '10px',
    padding: '16px',
    marginRight: '10px',
  },
}));

const MinimalLayout = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        elevation={0}
        className={classes.appBar}
      >
        <Toolbar>
          <Header />
        </Toolbar>
      </AppBar>

      <main className={classes.content}>
        <Outlet />
      </main>
    </div>
  );
};

export default MinimalLayout;
